import { getVramUtilization } from '@/features/monitoring/api/prometheusApi';

import { createGpuMetricHook } from './createGpuMetricHook';

/**
 * VRAM 사용률 조회 Hook
 */
export const useVramUtilization = createGpuMetricHook('vram-utilization', getVramUtilization);
